import { useEffect, useState } from 'preact/hooks';

function useMediaQuery(query) {
  const [matches, setMatches] = useState();

  useEffect(() => {
    const mediaQuery = window.matchMedia(
      typeof query === 'number' ? `(min-width: ${query}px)` : query
    );
    const handleChange = () => setMatches(mediaQuery.matches);

    mediaQuery.addEventListener('change', handleChange);
    handleChange();

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, [query]);

  return matches;
}

export default useMediaQuery;
